import { Stack } from '@mui/material';
import { HeaderBreadcrumbs, ScreenWrap } from '../../components';
import { useParams } from 'react-router';
import LessonForm from './LessonForm';

export default function CreateLessonScreen() {
  const { weekNumber, weekId } = useParams();

  return (
    <ScreenWrap>
      <Stack gap={3}>
        <HeaderBreadcrumbs
          title="Create Lesson"
          items={[
            {
              name: `Program Week ${weekNumber}`,
              url: `/program/${weekNumber}/${weekId}/lessons`,
            },
          ]}
        />
        <LessonForm existing={undefined} />
      </Stack>
    </ScreenWrap>
  );
}
